// eslint-disable-next-line
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const blacklist = [
  'aol.com',
  'bol.com.br',
  'feedbackhunter.com.br',
  'feedz.com.br',
  'felizz.com.br',
  'globo.com',
  'gmail.com',
  'gmx.com',
  'hero365.com.br',
  'hotmail.com',
  'icloud.com',
  'ig.com.br',
  'live.com',
  'lockbin.com',
  'mail.ru',
  'msn.com',
  'outlook.com',
  'outlook.live.com',
  'pinpeople.com.br',
  'protonmail.com',
  'pulses.com.br',
  'qq.com',
  'sapo.pt',
  'talentacademy.com.br',
  'teamhub.com.br',
  'tutanota.com',
  'uol.com.br',
  'vaipe.com.br',
  'yahoo.com',
  'yahoo.com.br',
  'yandex.com',
  'zoho.com',
  'selpeadvisory.com.br',
  'gruposelpe.com.br',
  'gilfun.com',
  'aprimail.com',
  'etoymail.com',
  'chordmi.com',
  'qortu.com',
  'teamupp.com.br',
  'srv1.mail-tester.com',
  'habaut.com.br',
  'hurst.capital',
  'codecase.com.br',
  'terra.com.br',
  'ufu.br',
  'fampfaculdade.com.br',
  'menece.com',
  'art2427.com',
  'estudante.sed.gov.br',
  'snowmanlabs.com',
  'estudante.se.df.gov.br',
  'estudante.ifb.edu.br',
  'edu.ce.senac.br',
  'intelligenzait.com',
  'coblue.com.br',
  'frnla.com',
  'senior.com.br',
  'deloitte.com',
  'falconi.com',
  'exprexxctb.com.br',
  'd4wan.com',
  'bbsaili.com',
  'kenoby.com',
  'totvs.com.br',
  'werecruiter.io',
  'maisperformance.me',
  'werecruiter.tech',
  'usp.br',
  'aluno.facmais.edu.br',
  '@me.com',
  'rentoys.in',
  'happyjourney.page',
  'roads.run',
  'tish.ai',
  'edp.com',
  'potencialcompliance.com',
  'wawue.com',
  'wii999.com',
  'alunos.utfpr.edu.br',
  'silbarts.com',
  'comqual.com.br',
  // avoid client new accounts
  'portoseguro.com.br',
  'boavistascpc.com.br',
  'boavistatecnologia.com.br',
  'boavistaservicos.com.br',
  'grupoboticario.com.br',
  'grupoboticario.com',
  'boticario.com.br',
  'boticario.com',
  'oboticario.com.br',
  'e-boticario.com.br',
  'eudora.com.br',
  'e-boticario.com',
  'boticario.net',
  'mandic.net.br',
  'eudora.com',
  'webbytelecom.com.br',
  'webbytelecom.com',
  'oboticario.pt',
  'angolacables.co.ao',
  'bernhoeft.com.br',
  'hbsis.com.br',
  'matera.com.br',
  'belezanaweb.com.br',
  'e-quemdisseberenice.com.br',
  'beautybox.com.br',
  'ambevtech.com.br',
  'ambev.com',
  'ambev.com.br',
  'vitreo.com.br',
  'matera.com',
  'tial.com.br',
  'novomundo.com.br',
  'novomundo.com',
  'setainsp.com.br',
  'galvani.ind.br',
  'gboticario.onmicrosoft.com',
  'galvani.com.br',
  'vr.com.br',
  'tc.com.br',
  'randon.com.br',
  'gavb.com.br',
  'tradersclub.com.br',
  'aju.jamef.com.br',
  'bar.jamef.com.br',
  'bhz.jamef.com.br',
  'bnu.jamef.com.br',
  'bsb.jamef.com.br',
  'cpq.jamef.com.br',
  'cwb.jaemf.com.br',
  'cwb.jamef.com.br',
  'div.jamef.com.br',
  'fes.jamef.com.br',
  'fes.jamef;com.br',
  'fln.com.br',
  'fln.jamef.com.br',
  'for.jamef.com.br',
  'gyn.jamef.com.br',
  'itj.jamef.com.br',
  'jamef.com.br',
  'joi.jamef.com.br',
  'jpa.jamef.com.br',
  'ldb.jamef.com.br',
  'mao.jamef.com.br',
  'mcz.jamef.com.br',
  'nat.jamef.com.br',
  'poa.jamef.com.br',
  'rao.jamef.com.br',
  'rec.jamef.com.br',
  'rio.jamef.com.br',
  'sao.jamef.com.br',
  'sjp.jamef.com.br',
  'ssa.jamef.com.br',
  'udi.jamef.com.br',
  'vdc.jamef.com.br',
  'vix.jamef.com.br',
  'sciensa.com',
  'megamoda.com.br',
  'torratorra.com.br',
  'lojastorra.com.br',
  'sebsa.com.br',
  'escolaluminova.com.br',
  'sebsa.com',
  'conexia.com.br',
  'conceptedu.com.br',
  'conceptedu.com',
  'escolaseb.com.br',
  'escolaconcept.com.br',
  'dombosco.sebsa.com.br',
  'schaeffler.com',
  'professorpueri.com.br',
  'mbcentral.com.br',
  'ms.conceptstudent.com.br',
  'pueridomus.sebsa.com.br',
  'unidombosco.edu.br',
  'casamagalhaes.com.br',
  'pueridomus.com.br',
  'epd.edu.br',
  'einsteinribeirao.com.br',
  'sartreseb.com.br',
  'conexiaeducacao.com.br',
  'admpueri.com.br',
  'prof.unidombosco.edu.br',
  'iteris.com.br',
  'academicoesfera.com.br',
  'megamodapark.com.br',
  'livup.com.br',
  'eps.eng.br',
  'mr3logistica.com.br',
  // 'cashme.com.br',
  'labsit.io',
  'comeialabs.com.br',
  'nuvem.net',
  'omegageracao.com.br',
  'omeganergia.com.br',
  'professorpueri.com',
  'seb.edu.br',
  'seb.com.br',
  'seb.com',
  'puericandanguinho.com.br',
  'sebsa.dombosco.com.br',
  'br.clara.net',
  'institutoseb.org.br',
  'omegaenergia.com.br',
  'medicamental.com.br',
  'medicamental.com',
  'salesianorecife.com.br',
  'cooperflora.com.br',
  'maplebear.com.br',
]

export const isInBlacklist = email => {
  const foundEmail = blacklist.filter(e => email.toLowerCase().includes(e))
  return foundEmail.length > 0 ? true : false
}

export const isEmail = email => EMAIL_PATTERN.test(String(email).toLowerCase())

export default {
  isInBlacklist,
  isEmail,
  EMAIL_PATTERN,
}
